__webpack_require__.p = "https://www.ikea.com/ch/de/purchase-agent/cart-tmp/";